import { createSimpleContext } from "./helper";
export const {
  use: useArgs,
  provider: ArgsProvider
} = createSimpleContext({
  name: "Args",
  init: props => props
});